/**
 * Project fonts (ManagerController.GetFont in Unity). The project setting
 * `settings.font` holds one of these keys; unknown values fall back to the
 * default. The fonts are free ones in place of the Unity app's, scaled to
 * their widths (public/libraries/fonts/README.md): the default is Noto Sans
 * (Segoe UI in Unity), "Make It" is Montserrat Light (Nexa Light) and the
 * school cursive is Playwrite ES (Escolar). @font-face rules: styles.css.
 */
export const FONT_FAMILIES: Record<string, string> = {
  defaultArabic: "MakeItDefault",
  nexaLight: "MakeIt Light",
  quicksand: "Quicksand",
  roboto: "Roboto",
  spartan: "Spartan",
  openDyslexic: "OpenDyslexic",
  cursive: "MakeIt Cursive",
};

export function fontFamilyFor(font: string | null | undefined): string {
  const family = (font && FONT_FAMILIES[font]) || FONT_FAMILIES.defaultArabic;
  // "MakeItDefault" is always in the stack so Arabic/Hebrew glyphs missing
  // from the chosen font come from the default font, as Utilities.ToRtl does
  // in Unity.
  return family === FONT_FAMILIES.defaultArabic ? `"${family}", "Segoe UI", system-ui, sans-serif` : `"${family}", "MakeItDefault", "Segoe UI", system-ui, sans-serif`;
}

/** Unity draws the cursive (Escolar) font 30 px bigger (ChangeFont.cs); MakeIt Cursive is scaled to Escolar's widths. */
export function fontSizeAdjust(font: string | null | undefined): number {
  return font === "cursive" ? 30 : 0;
}

/** The fonts' names in the editor and the settings (not translated, as in the app). */
export const FONT_LABELS: Record<string, string> = {
  nexaLight: "Make It",
  quicksand: "Quicksand",
  roboto: "Roboto",
  spartan: "Spartan",
  openDyslexic: "Open Dyslexic",
  cursive: "School cursive",
};
